export const isEmptyOrWhitespace = (value: string | undefined | null): boolean => {
  return !value || value.trim() === '';
};

export const isEmptyArray = (arr: any[] | undefined): boolean => {
  return !arr || arr.length === 0;
};
